<div class="custom-dropdown">
  <div class="input-filtro-selecionado">
    <button type="button" class="dropdown-toggle" (click)="toggleAcoes()">
      <img
        src="{{ BASE_IMG_URL }}assets/agenda-tarefas/filter.svg"
        width="20"
        height="20"
      />
      {{
        filtroAcoesSelecionados.length === 0
          ? "Todas as ações"
          : filtroAcoesSelecionados.length + " ação(ões) selecionada(s)"
      }}
    </button>
    <button
      *ngIf="filtroAcoesSelecionados.length"
      type="button"
      class="btn-clear"
      (click)="limparAcoes()"
    >
      ×
    </button>
  </div>
  <div *ngIf="mostrarAcoes" class="dropdown-list">
    <label *ngFor="let acao of acoes">
      <input
        type="checkbox"
        [checked]="filtroAcoesSelecionados.includes(acao)"
        (change)="onAcoesToggle(acao, $event)"
      />
      {{ acao.description }}
    </label>
  </div>
</div>
